import { Form, Input, Modal } from 'antd';
import 'moment/locale/es';
import { authFetch } from '../../../../../common/request/authFetch';
import { InfoCircleOutlined } from '@ant-design/icons';

export const NewKeywordModal = (props: {
	projectId: string;
	composeId: string;
	scope: string;
	websiteUri: string;
	onFinish: any;
}) => {

	const [form] = Form.useForm();

	const onFormFinish = async (values: any) => {
		const data = {
			...values,
			scope: props.scope,
			websiteUri: props.websiteUri,
		};

		await authFetch(
			`${process.env.REACT_APP_API}/projects/${props.projectId}/keywords/${props.composeId}/terms`,
			{ method: 'POST', data }
		);
		props.onFinish();
	};

	return (
		<Modal open={true} onOk={() => form.submit()} onCancel={props.onFinish} afterClose={form.resetFields}>
			<h2>Añadir keyword</h2>
			<i style={{ color: 'Teal' }}>
				<InfoCircleOutlined /> Tener en cuenta Categoría, localización, servicios y productos. Por ejemplo <b>"Clínica Dental"</b>, <b>"Córdoba"</b>, <b>"Ortodoncia"</b>, etc,...
			</i>
			<br /><br />
			<Form layout='horizontal' form={form} onFinish={onFormFinish}>
				<Form.Item
					rules={[{ required: true, message: 'Por favor, ingrese la keyword' }]}
					name='keyword'
					label='Keyword'
				>
					<Input />
				</Form.Item>
			</Form>
		</Modal>
	);
};
